export default "/images/icons8-austria.png?c0dd22d952454d73f71bd09c63e29a5e";